<template>
<div class="title-wrapper">
  <!-- スマホ: 縦並び -->
  <div class="mobile-layout">
    <div class="mobile-back" v-if="showBackButton">
      <button class="back-button" @click="$router.go(-1)">
        <img src="/img/back_icon.png" alt="back" />
      </button>
    </div>
    <div class="mobile-image" v-if="packItem">
      <img class="product-banner" :src="packItem.image" />
    </div>
    <div class="mobile-title">
      <span class="jpn">{{ jpn }}</span>
    </div>
  </div>

  <!-- PC: 横並び（従来通り） -->
  <div class="pc-layout">
    <div class="left" v-if="showBackButton">
      <button class="back-button" @click="$router.go(-1)">
        <img src="/img/back_icon.png" alt="back" />
      </button>
    </div>
    <span class="jpn">{{ jpn }}</span>
    <div class="right" v-if="packItem">
      <img class="product-banner" :src="packItem.image" />
    </div>
  </div>
</div>
</template>

<script>

export default {
  props: {
    jpn: {
      type: String,
      default: '',
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    packItem: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
// PC表示（デフォルト）
.mobile-layout {
  display: none;
}
.pc-layout {
  position: relative;
  display: flex;
  height: auto;
  justify-content: space-between;
  color: $gray2;
  font-size: 24px;
  font-weight: bold;
  align-items: flex-end;
  border-bottom: 1px solid $gray2;
}

.pc-layout .left {
  flex: 1;
  display: flex;
  align-items: flex-end;
  .back-button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    img {
      width: 50px;
    }
  }
}

.pc-layout .right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
  width: auto;
  max-width: 200px;
  img {
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
    height: auto;
    max-width: 200px;
  }
}

.pc-layout .jpn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

// スマホ表示
@media screen and (max-width: $mobileWidth) {
  .pc-layout {
    display: none;
  }
  .mobile-layout {
    display: flex;
    flex-direction: column;
    color: $gray2;
    font-weight: bold;
  }
  .mobile-back {
    .back-button {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      img {
        width: 40px;
      }
    }
  }
  .mobile-image {
    width: 100%;
    margin: 10px 0;
    img {
      width: 100%;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
    }
  }
  .mobile-title {
    border-bottom: 1px solid $gray2;
    padding-bottom: 8px;
    .jpn {
      font-size: 20px;
    }
  }
}

// タブレット
@media screen and (min-width: $mobileWidth + 1) and (max-width: $tabletWidth) {
  .pc-layout {
    height: 96px;
    font-size: 20px;
    .left {
      .back-button {
        img {
          width: 40px;
        }
      }
    }
    .right {
      img {
        max-width: 150px;
      }
    }
  }
}
</style>
